import { useMutation } from 'react-query';
import { useQuickUploadFile } from 'contexts/QuickUploadFile';
import { AnchorAPI } from '../../modules/AnchorAPI';

function useUploadFileMultipart() {
  const { setQuickUploadFile } = useQuickUploadFile();
  const { mutate, status } = useMutation(
    ({
      file,
      onFetchSignedUrlSuccess,
      onProgress,
      onError,
    }: {
      file: File;
      onFetchSignedUrlSuccess: (requestUuid: string) => void;
      onProgress: (xhr: XMLHttpRequest, loaded: number, total: number) => void;
      onError: () => void;
    }) => {
      return AnchorAPI.uploadFileMultipart({
        file,
        onFetchSignedUrlSuccess,
        onProgress,
        onError,
      });
    },
    {
      onSuccess: () => {
        setQuickUploadFile(null);
      },
    }
  );

  return { uploadFileMultipart: mutate, uploadFileMultipartStatus: status };
}

export { useUploadFileMultipart };
